import { AfterViewInit, Component, ElementRef, HostListener, Input, ViewChild, inject, output } from '@angular/core'
import { IBvComment, IBvUser } from '@modules/bv-api'
import { Store } from '@ngrx/store'
import { getOrganizationUsers, getUser } from '@ziptility/store'
import { BvCommentComponent } from '../comment/comment.component'
import { BvMentionInputComponent } from '../../bv-mention/bv-mention-input.component'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'bv-comments',
  template: `
    <div class="flex flex-col items-stretch h-full">
      <div class="overflow-auto h-full" #listContainer>
        @for (comment of comments; track comment) {
          <bv-comment
            [users]="users$ | async"
            [user]="user$ | async"
            [comment]="comment"
            (onUpdate)="onUpdate.emit($event)"
            (onDelete)="onDelete.emit($event)"
          >
          </bv-comment>
        }
      </div>
      <bv-mention-input
        [users]="users$ | async"
        [message]="message"
        (onMessageChange)="onMessageChange($event)"
        (onSubmit)="onSubmit()"
      ></bv-mention-input>
    </div>
  `,
  host: {
    class: 'w-full',
  },
  imports: [BvCommentComponent, BvMentionInputComponent, AsyncPipe],
})
export class BvCommentsComponent implements AfterViewInit {
  readonly store = inject(Store)
  message = ''
  mentions: IBvUser[] = []
  user$ = this.store.select(getUser)
  users$ = this.store.select(getOrganizationUsers)

  readonly onCreate = output<{
    message: string
    mentions: IBvUser[]
  }>()

  readonly onUpdate = output<any>()

  readonly onDelete = output<any>()

  @ViewChild('listContainer', { static: true }) listContainer: ElementRef

  _comments: IBvComment[]
  @Input()
  set comments(value: IBvComment[]) {
    this._comments = value
    setTimeout(() => {
      this.scrollToBottom()
    }, 100)
  }
  get comments() {
    return this._comments
  }

  ngAfterViewInit() {
    this.scrollToBottom()
  }

  scrollToBottom() {
    this.listContainer.nativeElement.scrollTop = this.listContainer.nativeElement.scrollHeight
  }

  @HostListener('keyup.enter', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    event.preventDefault()
    event.stopPropagation()
    this.onSubmit()
  }

  onSubmit() {
    const mes = this.message?.trim()
    if (mes) {
      this.onCreate.emit({ message: mes, mentions: this.mentions })
    }

    this.message = undefined
  }

  onMessageChange({ message, mentions }) {
    this.message = message
    this.mentions = mentions
  }
}
